import { Subject, ReplaySubject } from 'rxjs';

function manageNamespace(name) {
    let parts = name.split('.');
    const obj = {
        namespace: 'generic',
        eventname: name
    };
    if(parts.length > 1) {
        obj.eventname = parts.pop();
        obj.namespace = parts.splice(-1).join('.');
    }
    return obj;
}

function removeHandler(handler, observers) {
    for (let i = 0;i < observers.length;i++) {
        if (observers[i].destination._next === handler) {
            observers[i].unsubscribe();
            return;
        }
    }
}

const builder = {
    on(context, namespaceObj, subjectFn, handler) {
        context.events[namespaceObj.namespace] = context.events[namespaceObj.namespace] || {};
        if (!context.events[namespaceObj.namespace][namespaceObj.eventname]) {
            context.events[namespaceObj.namespace][namespaceObj.eventname] = {};
            context.events[namespaceObj.namespace][namespaceObj.eventname].subject = new subjectFn();
        }
        context.events[namespaceObj.namespace][namespaceObj.eventname].subject.subscribe(handler);
    },
    off(context, namespaceObj, handler) {
        if (context.events[namespaceObj.namespace] && context.events[namespaceObj.namespace][namespaceObj.eventname]) {
            if (handler) {
                removeHandler(handler, context.events[namespaceObj.namespace][namespaceObj.eventname].subject.observers);
            } else {
                context.events[namespaceObj.namespace][namespaceObj.eventname].subject.unsubscribe();
                delete context.events[namespaceObj.namespace][namespaceObj.eventname];
            }
        }
    },
    once(context, namespaceObj, subjectFn, handler) {
        context.events[namespaceObj.namespace] = context.events[namespaceObj.namespace] || {};
        if (!context.events[namespaceObj.namespace][namespaceObj.eventname]) {
            context.events[namespaceObj.namespace][namespaceObj.eventname] = {};
            context.events[namespaceObj.namespace][namespaceObj.eventname].subject = new subjectFn();
            context.events[namespaceObj.namespace][namespaceObj.eventname].once = true;
        }
        context.events[namespaceObj.namespace][namespaceObj.eventname].subject.subscribe(handler);
    },
    trigger(context, namespaceObj, subjectFn, data) {
        context.events[namespaceObj.namespace] = context.events[namespaceObj.namespace] || {};
        if (!context.events[namespaceObj.namespace][namespaceObj.eventname]) {
            context.events[namespaceObj.namespace][namespaceObj.eventname] = {};
            context.events[namespaceObj.namespace][namespaceObj.eventname].subject = new subjectFn();
        }
        let response = {
            eventName: namespaceObj.eventname,
            eventNamespace: namespaceObj.namespace,
            output: data
        };
        context.events[namespaceObj.namespace][namespaceObj.eventname].subject.next(response);
        if (context.events[namespaceObj.namespace]['*']) {
            context.events[namespaceObj.namespace]['*'].subject.next(response);
        }
        if (context.events[namespaceObj.namespace] &&
            context.events[namespaceObj.namespace][namespaceObj.eventname] &&
            context.events[namespaceObj.namespace][namespaceObj.eventname].once) {
            this.off(context, namespaceObj);
        }
    }
};

const LIFE_CYCLE_EVENT_BUS = {
    events: {},
    on(name, handler) {
        const namespaceObj = manageNamespace(name);
        builder.on(this, namespaceObj, Subject, handler);
    },
    off(name, handler) {
        const namespaceObj = manageNamespace(name);
        builder.off(this, namespaceObj, handler);
    },
    once(name, handler) {
        const namespaceObj = manageNamespace(name);
        builder.once(this, namespaceObj, Subject, handler);
    },
    trigger(name, data) {
        const namespaceObj = manageNamespace(name);
        builder.trigger(this, namespaceObj, Subject, data);
    },
    lifeCycle: {
        events: {},
        on(name, handler) {
            const namespaceObj = manageNamespace(name);
            builder.on(this, namespaceObj, ReplaySubject, handler);
        },
        off(name, handler) {
            const namespaceObj = manageNamespace(name);
            builder.off(this, namespaceObj, handler);
        },
        trigger(name, data) {
            const namespaceObj = manageNamespace(name);
            builder.trigger(this, namespaceObj, ReplaySubject, data);
        }
    }
};

export { LIFE_CYCLE_EVENT_BUS };
